import CrossSellGalleryElement from '../CrossSellGalleryElement/CrossSellGalleryElement';
import CrossSellGalleryElementPresets from '../CrossSellGalleryElement/CrossSellGalleryElementPresets';
import MobileCrossSellGalleryElementMetaData from './MobileCrossSellGalleryElementMetaData';
import MobileCrossSellGalleryElementProps from './MobileCrossSellGalleryElementProps';
import { getInteractiveElements, refreshInteractiveElementsList } from '../CrossSellGalleryElement/CrossSellGalleryElement';

export default {
  metaData: MobileCrossSellGalleryElementMetaData,
  elementClass: CrossSellGalleryElement,
  elementProps: MobileCrossSellGalleryElementProps,
  presets: CrossSellGalleryElementPresets,
  methods: { getInteractiveElements, refreshInteractiveElementsList }
};
